/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, Global, jsx } from '@emotion/react'; // oxlint-disable-line typescript-eslint/consistent-type-imports -- jsx used via classic JSX pragma

import cssReset from '@atlaskit/css-reset';
import { token } from '@atlaskit/tokens/token';

import { BRAND_COLORS } from '../constants/brand-colors';

// Docs-specific continuation of the ADS radius scale beyond radius.xxlarge (16px).
// These card sizes follow the original 3XL (20px) step in that extension.
const CARD_RADIUS_4XL = '24px';
const CARD_RADIUS_5XL = '32px';
const CARD_RADIUS_6XL = '40px';

/**
 * CSS Reset + general global styling hacks for all of Design System Docs
 */
const GlobalStyles = (): jsx.JSX.Element => (
	<Global
		// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @repo/internal/react/no-css-string-literals -- Ignored via go/DSP-18766
		styles={css`
			${
				// eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values
				cssReset
			}
			* {
				box-sizing: inherit;
			}
			body,
			html {
				box-sizing: border-box;
				background-color: ${token('elevation.surface', '#ffffff')};
			}

			img {
				max-width: 100%;
			}

			/* CSS Reset sets marginTop of elements to 0 using first-child, which doesn't work with SSR.
			This override avoid margins jumping after SSR */
			:first-child:is(p, ul, ol, dl, h1, h2, h3, h4, h5, h6, blockquote, pre, form, table),
			style:first-child + :is(p, ul, ol, dl, h1, h2, h3, h4, h5, h6, blockquote, pre, form, table) {
				margin-top: 0;
			}

			#___gatsby {
				isolation: isolate; /* Hack to start new stacking context for content to prevent layering issues with portals */
			}

			/* Remove focus ring from #main-content */
			#main-content:focus {
				outline: none;
			}

			/* Shared brand colors, artwork fills and responsive card radii */
			:root {
				--nav-backdrop-color: rgba(from ${token('elevation.surface')} r g b / 0.85);

				--ad-color-brand-blue: ${BRAND_COLORS.blue};
				--ad-color-brand-purple: ${BRAND_COLORS.purple};
				--ad-color-brand-saffron: ${BRAND_COLORS.orange};
				--ad-color-brand-lime: ${BRAND_COLORS.lime};
				--ad-color-brand-obsidian: ${BRAND_COLORS.black};

				/* Pure black/white artwork fill, flipped by color mode further down. Done in
				   CSS rather than JS so the prerendered markup is identical for every reader
				   and hydration cannot mismatch. */
				--ad-color-artwork-fill: black;

				--motion-duration-reveal: 700ms;
				--motion-ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);

				--ad-radius-card: ${CARD_RADIUS_4XL};

				@media (min-width: 48rem) {
					--ad-radius-card: ${CARD_RADIUS_5XL};
				}
				@media (min-width: 64rem) {
					--ad-radius-card: ${CARD_RADIUS_6XL};
				}

				/* The leading '&' matters: a bare ':root[...]' nested here compiles to the
				   descendant selector ':root :root[...]', which never matches. */
				&[data-color-mode='dark'] {
					--ad-color-artwork-fill: white;
				}
			}
		`}
	/>
);

export default GlobalStyles;
